import { createSlice } from "@reduxjs/toolkit";
import { fetchProjectManagerTaksAssignList } from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  currentPage: number;
  totalPages: number;
  loading: boolean;
  error: string | null;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  currentPage: 1,
  totalPages: 1,
  loading: false,
  error: null,
};

const ProjectManageTaksAssignList = createSlice({
  name: "ProjectManagerTaksList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectManagerTaksAssignList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectManagerTaksAssignList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.list || [];
        state.rowCount = action.payload.rowCount;
       
      })
      .addCase(fetchProjectManagerTaksAssignList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch ProjectManager Manpower Allocation List";
      });
  },
});export default ProjectManageTaksAssignList.reducer;
